import { SHOW_LVZ_INFOWINDOW,  HIDE_LVZ_INFOWINDOW} from "./lvzInfoWindowReducer"

export const showLvzInfoWindow = (obj) => ({
    type: SHOW_LVZ_INFOWINDOW,
    payload: obj
})

export const hideLvzInfoWindow = () => ({
    type: HIDE_LVZ_INFOWINDOW,
})